import { render } from "./VisaComponent.vue?vue&type=template&id=34889911"
import script from "./VisaComponent.vue?vue&type=script&lang=js"
export * from "./VisaComponent.vue?vue&type=script&lang=js"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__